<template>
<!-- CustomerData -->
<div class="w-full grid justify-items-center">
	<panel :title="$t('eny.applicant')" addclass="mt-4 w-full max-w-[1300px]">
		<form id="dashboard-applicant-form">
			<div class="flex flex-col sm:flex-row sm:gap-5 lg:gap-20">
				<!-- Col 1 -->
				<div class="flex flex-col sm:w-1/2">
					<div class="items-center mx-4">
						<!-- Gender -->
						<validation><ejs-combobox id='gender' name='gender' :dataSource='genders' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.salutation')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.gender"></ejs-combobox></validation>
						<!-- First Name -->
						<ejs-maskedtextbox id="fist_name" name="first_name" floatLabelType="Auto" :placeholder="$t('eny.firstname')" v-model:value="user_loc.given_name"></ejs-maskedtextbox>
						<!-- Last Name -->
						<ejs-maskedtextbox id="last_name" name="last_name" floatLabelType="Auto" :placeholder="$t('eny.lastname')" v-model:value="user_loc.family_name"></ejs-maskedtextbox>
						<!-- Language -->
						<ejs-combobox id='locale' name='locale' :dataSource='locales' :fields='localeFields' floatLabelType="Auto" :placeholder="$t('eny.locale')" :showClearButton="false" :allowCustom="false" v-model:value="user_loc.locale"></ejs-combobox>
						<!-- Customer street & nr -->
						<ejs-maskedtextbox id="cust_street" name="cust_street" floatLabelType="Auto" :placeholder="$t('eny.street_nr')" v-model:value="cur_address_loc.street"></ejs-maskedtextbox>
						<!-- Customer zip/city -->
						<div class="flex gap-4">
							<div class="w-1/3">
								<validation><ejs-maskedtextbox :change="handleChange" id="cust_zip" name="cust_zip" floatLabelType="Auto" :placeholder="$t('eny.zip')" v-model:value="cur_address_loc.zip"></ejs-maskedtextbox></validation>
							</div>
							<div class="w-2/3" v-if="this.multipleCity === true">
								<ejs-combobox id='cust_city' name='cust_city' :dataSource='this.cities' :fields='cityFields' floatLabelType="Auto" :placeholder="$t('eny.city')" :showClearButton="false" :allowCustom="false" v-model:value="cur_address_loc.city"></ejs-combobox>
							</div>
							<div class="w-2/3" v-else>
								<ejs-maskedtextbox id="cust_city" name="cust_city" floatLabelType="Auto" :placeholder="$t('eny.city')" v-model:value="cur_address_loc.city"></ejs-maskedtextbox>
							</div>
						</div>
						<!-- Customer address date -->
						<validation><ejs-datepicker id='cust_address_date' name='cust_address_date' floatLabelType="Auto" :placeholder="$t('eny.question_since_when')" :format="$t('eny.date_format')" :open='onOpen' v-model:value="request_loc.address_date"></ejs-datepicker></validation>
						<!-- Old address -->
						<div v-show="showOldAdress">
							<ejs-maskedtextbox id='prev_address' name='prev_address' floatLabelType="Auto" :placeholder="$t('eny.prev_address')" disabled=''></ejs-maskedtextbox>
						</div>
						<!-- Customer previous street & nr -->
						<div v-show="showOldAdress">
							<ejs-maskedtextbox id="cust_prev_street" name="cust_prev_street" floatLabelType="Auto" :placeholder="$t('eny.street_nr')" v-model:value="old_address_loc.street"></ejs-maskedtextbox>
						</div>
						<!-- Customer previous zip/city -->
						<div v-show="showOldAdress" class="flex gap-4">
							<div class="w-1/3">
								<validation><ejs-maskedtextbox :change="handleChange" id="cust_prev_zip" name="cust_prev_zip" floatLabelType="Auto" :placeholder="$t('eny.zip')" v-model:value="old_address_loc.zip"></ejs-maskedtextbox></validation>
							</div>
							<div class="w-2/3" v-if="this.oldAddressMultipleCity === true">
								<ejs-combobox id='cust_prev_city' name='cust_prev_city' :dataSource='this.oldAddressCities' :fields='cityFields' floatLabelType="Auto" :placeholder="$t('eny.city')" :showClearButton="false" :allowCustom="false" v-model:value="old_address_loc.city"></ejs-combobox>
							</div>
							<div class="w-2/3" v-else>
								<ejs-maskedtextbox id="cust_prev_city" name="cust_prev_city" floatLabelType="Auto" :placeholder="$t('eny.city')" v-model:value="old_address_loc.city"></ejs-maskedtextbox>
							</div>
						</div>
					</div>
				</div>
				<!-- Col 2 -->
				<div class="flex flex-col sm:w-1/2">
					<div class="items-center mx-4">
						<!-- DOB -->
						<validation><ejs-datepicker id='dob' name='dob' floatLabelType="Auto" :placeholder="$t('eny.dob')"  :format="$t('eny.date_format')" :open='onOpen' v-model:value="request_loc.dob" cssClass="form-group"></ejs-datepicker></validation>
						<!-- Nationality -->
						<validation><ejs-combobox id='nationality' name='nationality' :dataSource='nationalities' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.nationality')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.nationality"></ejs-combobox></validation>
						<!-- Residence permit -->
						<validation v-show="request_loc.nationality && request_loc.nationality != 'ch'"><ejs-combobox id='residence_permit' name='residence_permit' :dataSource='residence_permits' :fields='fields' :enableMask="true" floatLabelType="Auto" :placeholder="$t('eny.residence_permit')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.residence_permit"></ejs-combobox></validation>
						<!-- Entry date -->
						<validation v-show="request_loc.nationality && request_loc.nationality != 'ch'"><ejs-datepicker id='entry_date' name='entry_date' floatLabelType="Auto" :placeholder="$t('eny.entry_date')"  :format="$t('eny.date_format')" :open='onOpen' v-model:value="request_loc.entry_date"></ejs-datepicker></validation>
						<!-- E-Mail -->
						<ejs-maskedtextbox id="email" name="email" floatLabelType="Auto" :placeholder="$t('eny.email')" v-model:value="user_loc.email"></ejs-maskedtextbox>
						<!-- Phone -->
						<validation><ejs-maskedtextbox id="phone" name="phone" floatLabelType="Auto" :placeholder="$t('eny.mobphone')" v-model:value="user_loc.phone"></ejs-maskedtextbox></validation>
						<!-- Product -->
						<ejs-maskedtextbox id="product" name="product" floatLabelType="Auto" :placeholder="$t('eny.purpose_of_use')" v-model:value="request_loc.product"></ejs-maskedtextbox>
						<!-- pending enforcement -->
						<validation><ejs-combobox id='pending_enforcement' name='pending_enforcement' :dataSource='yes_no_answers' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.question_pending_enforcement')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.pending_enforcement"></ejs-combobox></validation>
						<!-- Civil status -->
						<ejs-combobox id='civil' name='civil' :dataSource='civil' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.civil_status')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.civil_status"></ejs-combobox>
					</div>
				</div>
			</div>
			<!-- save button: dashboard customer data -->
			<div class="w-full px-10 md:px-20 pt-5 flex flex-row justify-center">
				<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="saveDashboardCustomerData">{{$t('eny.save')}}</button>
				<button type="button" class="eny-btn-blue px-8 py-2 ml-3 text-2xl font-bold" @click="sendEmailToCustomer">{{$t('eny.send_offer_to_customer')}}</button>
			</div>
		</form>
	</panel>
</div>
<!-- Earnings -->
<div class="w-full grid justify-items-center">
	<panel :title="$t('eny.income')" addclass="mt-4 w-full max-w-[1300px]">
		<form id="dashboard-earnings-form">
			<div class="flex flex-col sm:flex-row sm:gap-5 lg:gap-20">
				<!-- Col 1 -->
				<div class="flex flex-col sm:w-1/2">
					<div class="items-center mx-4">
						<!-- Employment relationship -->
						<validation><ejs-combobox id='employment_rel' name='employment_rel' :dataSource='employment_rels' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.employment_rel')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.employment_rel"></ejs-combobox></validation>
						<!-- Employment relationship date -->
						<validation><ejs-datepicker id='employment_rel_date' name='employment_rel_date' floatLabelType="Auto" :placeholder="$t('eny.question_since_when')" :format="$t('eny.date_format')" :open='onOpen' v-model:value="request_loc.employment_rel_date"></ejs-datepicker></validation>
						<!-- Employer -->
						<ejs-maskedtextbox id="employer" name="employer" floatLabelType="Auto" :placeholder="$t('eny.employer')" v-model:value="request_loc.employer"></ejs-maskedtextbox>
						<!-- Employer street -->
						<ejs-maskedtextbox id="employer_street" name="employer_street" floatLabelType="Auto" :placeholder="$t('eny.street')" v-model:value="employer_address_loc.street"></ejs-maskedtextbox>
						<!-- Employer zip/city -->
						<div class="flex gap-4">
							<div class="w-1/3">
								<validation><ejs-maskedtextbox :change="handleChange" id="employer_zip" name="employer_zip" floatLabelType="Auto" :placeholder="$t('eny.zip')" v-model:value="employer_address_loc.zip"></ejs-maskedtextbox></validation>
							</div>
							<div class="w-2/3" v-if="this.employerMultipleCity === true">
								<ejs-combobox id='employer_city' name='employer_city' :dataSource='this.employerCities' :fields='cityFields' floatLabelType="Auto" :placeholder="$t('eny.city')" :showClearButton="false" :allowCustom="false" v-model:value="employer_address_loc.city"></ejs-combobox>
							</div>
							<div class="w-2/3" v-else>
								<ejs-maskedtextbox id="employer_city" name="employer_city" floatLabelType="Auto" :placeholder="$t('eny.city')" v-model:value="employer_address_loc.city"></ejs-maskedtextbox>
							</div>
						</div>
						<!-- Partner data -->
						<div v-show="request_loc.civil_status == '1'">
							<!-- Partner income title -->
							<ejs-maskedtextbox id='partner_income' name='partner_income' floatLabelType="Auto" :placeholder="$t('eny.partner_income')" disabled=''></ejs-maskedtextbox>
							<!-- Has partner income -->
							<validation><ejs-combobox id='cust_has_partner_income' name='cust_has_partner_income' :dataSource='yes_no_answers' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.has_partner_income')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.has_partner_income"></ejs-combobox></validation>
							<div v-show="request_loc.has_partner_income == 1">
								<!-- Customer partner first name -->
								<validation><ejs-maskedtextbox id="cust_partner_firstname" name="cust_partner_firstname" floatLabelType="Auto" :placeholder="$t('eny.firstname')" v-model:value="request_loc.partner_firstname"></ejs-maskedtextbox></validation>
								<!-- Customer partner last name -->
								<validation><ejs-maskedtextbox id="cust_partner_lastname" name="cust_partner_lastname" floatLabelType="Auto" :placeholder="$t('eny.lastname')" v-model:value="request_loc.partner_lastname"></ejs-maskedtextbox></validation>
								<!-- Customer partner dob -->
								<validation><ejs-datepicker id='cust_partner_dob' name='cust_partner_dob' floatLabelType="Auto" :placeholder="$t('eny.dob')" :format="$t('eny.date_format')" :open='onOpen' v-model:value="request_loc.partner_dob"></ejs-datepicker></validation>
								<!-- Nationality -->
								<validation><ejs-dropdown id='cust_partner_nationality' name='cust_partner_nationality' :dataSource='nationalities' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.nationality')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.partner_nationality"></ejs-dropdown></validation>
								<!-- Customer partner phone -->
								<validation><ejs-maskedtextbox id="cust_partner_phone" name="cust_partner_phone" floatLabelType="Auto" :placeholder="$t('eny.mobphone')" v-model:value="request_loc.partner_phone"></ejs-maskedtextbox></validation>
								<!-- Employment relationship -->
								<validation><ejs-dropdown id='cust_partner_employment_rel' name='cust_partner_employment_rel' :dataSource='employment_rels' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.employment_rel')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.partner_employment_rel"></ejs-dropdown></validation>
								<!-- Customer partner monthly income -->
								<validation>
									<div class="flex flex-row">
										<ejs-numerictextbox id="cust_partner_monthly_salary" format='# ###' :showSpinButton="false" name="cust_partner_monthly_salary" floatLabelType="Auto" :placeholder="$t('eny.monthly_salary')" v-model:value="request_loc.partner_monthly_salary"></ejs-numerictextbox>
										<text-box-extension :label="$t('eny.chf')" />
									</div>
								</validation>
								<!-- Number of partner monthly salary -->
								<validation><ejs-combobox id='cust_partner_salary_number' name='cust_partner_salary_number' :dataSource='monthly_salary_amounts' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.number_of_monthly_salary')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.partner_salary_number"></ejs-combobox></validation>
								<!-- Customer partner employer -->
								<validation><ejs-maskedtextbox id="cust_partner_employer" name="cust_partner_employer" floatLabelType="Auto" :placeholder="$t('eny.employer')" v-model:value="request_loc.partner_employer"></ejs-maskedtextbox></validation>
								<!-- Customer partner employer street nr -->
								<validation><ejs-maskedtextbox id="cust_partner_employer_street_nr" name="cust_partner_employer_street_nr" floatLabelType="Auto" :placeholder="$t('eny.street_nr')" v-model:value="request_loc.partner_employer_street_nr"></ejs-maskedtextbox></validation>
								<!-- Employer zip/city -->
								<div class="flex gap-4">
									<div class="w-1/3">
										<validation><ejs-maskedtextbox :change="handleChange" id="cust_partner_employer_zip" name="cust_partner_employer_zip" floatLabelType="Auto" :placeholder="$t('eny.zip')" v-model:value="request_loc.partner_employer_zip"></ejs-maskedtextbox></validation>
									</div>
									<div class="w-2/3" v-if="this.partnerCityMultiple === true">
										<ejs-combobox id='cust_partner_employer_city' name='cust_partner_employer_city' :dataSource='this.partnerCities' :fields='cityFields' floatLabelType="Auto" :placeholder="$t('eny.city')+$t('eny.required')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.partner_employer_city"></ejs-combobox>
									</div>
									<div class="w-2/3" v-else>
										<ejs-maskedtextbox id="cust_partner_employer_city" name="cust_partner_employer_city" floatLabelType="Auto" :placeholder="$t('eny.city')" v-model:value="request_loc.partner_employer_city"></ejs-maskedtextbox>
									</div>
								</div>
								<!-- Customer partner employer rel since -->
								<validation><ejs-datepicker id='cust_partner_employer_rel_since' name='cust_partner_employer_rel_since' floatLabelType="Auto" :placeholder="$t('eny.question_since_when')" :format="$t('eny.date_format')" :open='onOpen' v-model:value="request_loc.partner_employer_rel_since"></ejs-datepicker></validation>
							</div>
						</div>
					</div>
				</div>
				<!-- Col 2 -->
				<div class="flex flex-col sm:w-1/2">
					<div class="items-center mx-4">
						<!-- Last monthly salary -->
						<div class="flex flex-row">
							<ejs-numerictextbox id="last_monthly_salary" format='# ###' :showSpinButton="false" name="last_monthly_salary" floatLabelType="Auto" :placeholder="$t('eny.last_monthly_salary')" v-model:value="request_loc.salary_last"></ejs-numerictextbox>
							<text-box-extension :label="$t('eny.chf')" />
						</div>
						<!-- Two months ago -->
						<div class="flex flex-row">
							<ejs-numerictextbox id="two_months_ago" format='# ###' :showSpinButton="false" name="two_months_ago" floatLabelType="Auto" :placeholder="$t('eny.two_months_ago')" v-model:value="request_loc.salary_2m_ago"></ejs-numerictextbox>
							<text-box-extension :label="$t('eny.chf')" />
						</div>
						<!-- Three months ago -->
						<div class="flex flex-row">
							<ejs-numerictextbox id="three_months_ago" format='# ###' :showSpinButton="false" name="three_months_ago" floatLabelType="Auto" :placeholder="$t('eny.three_months_ago')" v-model:value="request_loc.salary_3m_ago"></ejs-numerictextbox>
							<text-box-extension :label="$t('eny.chf')" />
						</div>
						<!-- Number of monthly salary -->
						<ejs-combobox  id='salary_number' name='salary_number' :dataSource='monthly_salary_amounts' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.number_of_monthly_salary')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.salary_number"></ejs-combobox>
						<!-- Bonus -->
						<div class="flex flex-row">
							<ejs-numerictextbox id="bonus" format='# ###' :showSpinButton="false" name="bonus" floatLabelType="Auto" :placeholder="$t('eny.bonus')" v-model:value="request_loc.bonus"></ejs-numerictextbox>
							<text-box-extension :label="$t('eny.chf')" />
						</div>
						<!-- Has add income -->
						<ejs-combobox id='has_add_income' name='has_add_income' :dataSource='yes_no_answers' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.question_additional_income_1')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.has_add_income"></ejs-combobox>
						<!-- Additional incomes  -->
						<div v-show="request_loc.has_add_income==1" class="flex flex-col items-center">
							<div v-for="(add_income, nr) in add_incomes_loc" :key="nr" class="w-full">
								<!-- Add income -->
								<div class="flex flex-row">
									<ejs-numerictextbox id="add_income" format='# ###' :showSpinButton="false" name="add_income" floatLabelType="Auto" :placeholder="$t('eny.extra_income')" v-model:value="add_income.amount"></ejs-numerictextbox>
									<text-box-extension :label="$t('eny.chf')" />
								</div>
								<!-- Income_type -->
								<ejs-combobox name='cust_income_type' :dataSource='income_types' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.income_type')" :showClearButton="false" :allowCustom="false" v-model:value="add_income.type"></ejs-combobox>
							</div>
							<!-- Add additional income -->
							<div v-show="add_incomes_loc.length < 3" class="w-full px-10 md:px-20 pt-6 flex flex-row justify-center">
								<button type="button" class="eny-btn-blue px-8 py-2 font-bold" @click="addAddIncome">{{$t('eny.extra_income')}}</button>
							</div>
						</div>
						<!-- has side job -->
						<ejs-combobox id='has_side_job' name='has_side_job' :dataSource='yes_no_answers' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.side_job')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.has_side_job"></ejs-combobox>
						<!-- side job -->
						<div v-show="request_loc.has_side_job == 1">
							<!-- side job income -->
							<div class="flex flex-row">
								<ejs-numerictextbox id="side_job_income" format='# ###' :showSpinButton="false" name="side_job_income" floatLabelType="Auto" :placeholder="$t('eny.side_job_income')" v-model:value="request_loc.side_job_income"></ejs-numerictextbox>
								<text-box-extension :label="$t('eny.chf')" />
							</div>
							<!-- Number of monthly side job income -->
							<ejs-combobox  id='side_job_income_nr' name='side_job_income_nr' :dataSource='monthly_salary_amounts' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.number_of_monthly_salary')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.side_salary_number"></ejs-combobox>
						</div>
						<!-- Placeholder -->
						<div class="hidden sm:inline-flex sm:invisible">
							<ejs-maskedtextbox id="placeholder" name="placeholder" floatLabelType="Auto"></ejs-maskedtextbox>
						</div>
						<div class="hidden sm:inline-flex sm:invisible">
							<ejs-maskedtextbox id="placeholder" name="placeholder" floatLabelType="Auto"></ejs-maskedtextbox>
						</div>
						<div class="hidden sm:inline-flex sm:invisible">
							<ejs-maskedtextbox id="placeholder" name="placeholder" floatLabelType="Auto"></ejs-maskedtextbox>
						</div>
					</div>
				</div>
			</div>
			<!-- save button: dashbord earnings data -->
			<div class="w-full px-10 md:px-20 pt-5 flex flex-row justify-center">
				<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="saveDashbordEarningsData">{{$t('eny.save')}}</button>
			</div>
		</form>
	</panel>
</div>
<!-- Expenses -->
<div class="w-full grid justify-items-center">
	<panel :title="$t('eny.expenses')" addclass="mt-4 w-full max-w-[1300px]">
		<form id="dashboard-expenses-form">
			<div class="flex flex-col sm:flex-row sm:gap-5 lg:gap-20">
				<!-- Col 1 -->
				<div class="flex flex-col sm:w-1/2">
					<div class="items-center mx-4">
						<!-- Has open loan -->
						<validation><ejs-combobox id='has_open_loan' name='has_open_loan' :dataSource='yes_no_answers' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.question_open_loan')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.has_open_loan"></ejs-combobox></validation>
						<!-- open loans -->
						<div v-show="request_loc.has_open_loan == 1" class="flex flex-col items-center">
							<div v-for="(open_loan, nr) in open_loans_loc" :key="nr" class="w-full">
								<!-- Bank -->
								<div>
									<ejs-combobox name='cust_loan_bank' :dataSource='banks' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.bank') + ' ' + (nr + 1)" :showClearButton="false" :allowCustom="false" v-model:value="open_loan.bank"></ejs-combobox>
								</div>
								<!-- Month rate -->
								<div class="flex flex-col items-center">
									<div class="w-full flex flex-row">
										<ejs-numerictextbox :id="'cust_loan_monthly_rate_' + nr" name="cust_loan_monthly_rate" format='# ###' :showSpinButton="false" floatLabelType="Auto" :placeholder="$t('eny.monthly_rate')" v-model:value="open_loan.month_rate"></ejs-numerictextbox>
										<text-box-extension :label="$t('eny.chf')" />
									</div>
								</div>
								<!-- Open balance -->
								<ejs-numerictextbox :id="'cust_loan_open_balance_' + nr" name="cust_loan_open_balance" format='# ###' :showSpinButton="false" floatLabelType="Auto" :placeholder="$t('eny.open_balance')" v-model:value="open_loan.open_balance"></ejs-numerictextbox>
							</div>
							<!-- Additional open loan -->
							<div v-show="open_loans_loc.length < 3" class="w-full px-10 md:px-20 py-3 pt-5 flex flex-row justify-center">
								<button type="button" class="eny-btn-blue px-8 py-2 font-bold" @click="addOpenLoan">{{$t('eny.other_existing_credit')}}</button>
							</div>
						</div>
						<!-- Living condition types -->
						<ejs-combobox id='cust_living_condition' name='cust_living_condition' :dataSource='living_condition_types' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.living_condition')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.living_condition"></ejs-combobox>
						<!-- Monthly housing expenses -->
						<div class="flex flex-row">
							<ejs-numerictextbox id="cust_monthly_housing_expenses" format='# ###' :showSpinButton="false" name="cust_monthly_housing_expenses" floatLabelType="Auto" :placeholder="$t('eny.monthly_housing_expenses')" v-model:value="request_loc.housing_expenses"></ejs-numerictextbox>
							<text-box-extension :label="$t('eny.chf')" />
						</div>
						<!-- Housing type -->
						<ejs-combobox id='housing_types' name='housing_types' :dataSource='housing_types' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.living_condition')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.housing_property"></ejs-combobox>
						<!-- Customer health insurance -->
						<div class="flex flex-row">
							<ejs-numerictextbox id="cust_health_insurance" format='# ###' :showSpinButton="false" name="cust_health_insurance" floatLabelType="Auto" :placeholder="$t('eny.health_insurance')" v-model:value="request_loc.health_insurance"></ejs-numerictextbox>
							<text-box-extension :label="$t('eny.chf')" />
						</div>
						<!-- Customer costs out of town meals -->
						<ejs-combobox id="cust_costs_out_of_town_meals" name='cust_costs_out_of_town_meals' :dataSource='yes_no_answers' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.costs_out_of_town_meals')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.costs_out_of_town_meals"></ejs-combobox>
						<div class="flex flex-row">
							<ejs-numerictextbox id="cust_costs_out_of_town_meals" format='# ###' :showSpinButton="false" name="cust_costs_out_of_town_meals" floatLabelType="Auto" :placeholder="$t('eny.costs_out_of_town_meals')" v-model:value="request_loc.costs_out_of_town_meals"></ejs-numerictextbox>
							<text-box-extension :label="$t('eny.chf')" />
						</div>
						<!-- Customer commute -->
						<div class="flex flex-row">
							<ejs-numerictextbox id="cust_commute" format='# ###' :showSpinButton="false" name="cust_commute" floatLabelType="Auto" :placeholder="$t('eny.commute')" v-model:value="request_loc.commute"></ejs-numerictextbox>
							<text-box-extension :label="$t('eny.chf')" />
						</div>
						<!-- Customer transport to work type -->
						<ejs-combobox id='cust_transport_to_work_type' name='cust_transport_to_work_type' :dataSource='transport_to_work_types' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.means_of_transport_to_work')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.transport_to_work_type"></ejs-combobox>
					</div>
				</div>
				<!-- Col 2 -->
				<div class="flex flex-col sm:w-1/2">
					<div class="items-center mx-4">
						<!-- Has open credit card balance -->
						<validation><ejs-combobox id='has_open_credit_card_balance' name='has_open_credit_card_balance' :dataSource='yes_no_answers' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.question_open_credit_card_balance')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.has_open_credit_card_balance"></ejs-combobox></validation>
						<!-- Open credit card balances -->
						<div v-show="request_loc.has_open_credit_card_balance == 1" class="flex flex-col items-center">
							<div v-for="(open_balance, nr) in open_balances_loc" :key="nr" class="w-full">
								<!-- Issuer -->
								<div>
									<ejs-combobox name='cust_balance_issuer' :dataSource='issuers' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.issuer') + ' ' + (nr + 1)" :showClearButton="false" :allowCustom="false" v-model:value="open_balance.issuer"></ejs-combobox>
								</div>
								<!-- Month rate -->
								<div class="flex flex-col items-center">
									<div class="w-full flex flex-row">
										<ejs-numerictextbox format='# ###' :showSpinButton="false" name="cust_balance_monthly_rate" floatLabelType="Auto" :placeholder="$t('eny.monthly_rate')" v-model:value="open_balance.month_rate"></ejs-numerictextbox>
										<text-box-extension :label="$t('eny.chf')" />
									</div>
								</div>
								<!-- Open balance -->
								<ejs-numerictextbox :id="'cust_balance_open_balance_' + nr" name="cust_open_balance" format='# ###' :showSpinButton="false" floatLabelType="Auto" :placeholder="$t('eny.open_balance')" v-model:value="open_balance.open_balance"></ejs-numerictextbox>
							</div>
							<!-- Add additional open balance -->
							<div v-show="open_balances_loc.length < 3" class="w-full px-10 md:px-20 py-3 pt-6 flex flex-row justify-center">
								<button type="button" class="eny-btn-blue px-8 py-2 font-bold" @click="addOpenBalance">{{$t('eny.other_existing_credit')}}</button>
							</div>
						</div>
						<!-- Number of dependent children -->
						<ejs-combobox id='cust_number_children' name='cust_number_children' :dataSource='children_counts' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.number_of_dependent_children')" :showClearButton="false" :allowCustom="false" v-model:value="children_loc.length" :select='selectChildrenNumber'></ejs-combobox>
						<!-- children age -->
						<div class="flex flex-col items-center">
							<div id="children_age" class="w-full">
								<div v-for="(child, nr) in children_loc" :key="nr" class="e-control-wrapper e-mask e-float-input !rounded-full !border-3 !border-color-2">
									<div class="flex flex-row gap-5 h-9">
										<div class="grow flex items-center pl-5">
											<ejs-slider v-model:value="child.age" type="MinRange" min="0" max="27" step="1"></ejs-slider>
										</div>
										<div class="flex flex-col items-center">
											<div class="bg-color-2 text-color-5 font-normal text-base rounded-full flex items-center h-full">
												<div class="flex flex-row px-4 w-24 justify-between">
													<div>{{child.age}}</div>
													<div>{{$t('eny.years')}}</div>
												</div>
											</div>
										</div>
									</div>
									<label class="e-float-text !text-color-2 !text-xs" style="transform: translate3d(-5px, -40px, 0) scale(1);">{{$t('eny.child_age', {nr: nr + 1})}}</label>
								</div>
							</div>
						</div>
						<!-- Pay for childcare -->
						<validation>
							<ejs-combobox id='pay_for_childcare' name='pay_for_childcare' :dataSource='yes_no_answers' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.child_care_monthly') + '?'" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.pay_for_childcare" v-if="children_loc.length > 0"></ejs-combobox>
						</validation>
						<!-- Child care monthly -->
						<div class="flex flex-row" v-if="(children_loc.length > 0) && request_loc.pay_for_childcare">
							<ejs-numerictextbox id="cust_child_care_monthly" format='# ###' :showSpinButton="false" name="cust_child_care_monthly" floatLabelType="Auto" :placeholder="$t('eny.child_care_monthly')" v-model:value="request_loc.child_care"></ejs-numerictextbox>
							<text-box-extension :label="$t('eny.chf')" />
						</div>
						<!-- Alimony monthly -->
						<div class="flex flex-row">
							<ejs-numerictextbox id="cust_alimony_monthly" format='# ###' :showSpinButton="false" name="cust_alimony_monthly" floatLabelType="Auto" :placeholder="$t('eny.alimony_monthly')" v-model:value="request_loc.alimony"></ejs-numerictextbox>
							<text-box-extension :label="$t('eny.chf')" />
						</div>
						<!-- Placeholder -->
						<div class="hidden sm:inline-flex sm:invisible">
							<ejs-maskedtextbox id="placeholder" name="placeholder" floatLabelType="Auto"></ejs-maskedtextbox>
						</div>
						<div class="hidden sm:inline-flex sm:invisible">
							<ejs-maskedtextbox id="placeholder" name="placeholder" floatLabelType="Auto"></ejs-maskedtextbox>
						</div>
					</div>
				</div>
			</div>
			<!-- save button: dashbord expenses data -->
			<div class="w-full px-10 md:px-20 pt-5 flex flex-row justify-center">
				<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="saveDashbordExpensesData">{{$t('eny.save')}}</button>
			</div>
		</form>
	</panel>
</div>
<!-- Documents -->
<dashboard-documents allowDelete="true"></dashboard-documents>
</template>

<script>
import { MaskedTextBoxComponent, SliderComponent, FormValidator, NumericTextBoxComponent } from '@syncfusion/ej2-vue-inputs';
import { ComboBoxComponent, DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import TextBoxExtension from "../../Helper/TextBoxExtension.vue";
import Panel from "../../Base/Panel.vue";
import Validation from "../../Base/Validation.vue";
import DashboardDocuments from "./DashboardDocuments.vue";
import useNotification from "../../hooks/useNotification";
import useUtils from '../../hooks/useUtils';
import { mapGetters } from 'vuex';
import axios from "axios";

export default {
	name: "DashboardDetail",
	components: {
		'panel': Panel,
		'validation': Validation,
		'ejs-maskedtextbox': MaskedTextBoxComponent,
		'ejs-combobox': ComboBoxComponent,
		'ejs-datepicker': DatePickerComponent ,
		'text-box-extension': TextBoxExtension,
		'ejs-slider' : SliderComponent,
		'dashboard-documents': DashboardDocuments,
		'ejs-numerictextbox': NumericTextBoxComponent,
		'ejs-dropdown': DropDownListComponent,
	},
	setup() {
		const { showNotification } = useNotification();
		const { sleep, sortList, timeZoneOffsetOnInit, timeZoneOffsetOnSave, isDateBefore, compareDates, isFormattedDateValid } = useUtils();
		return {
			showNotification,
			sleep,
			sortList,
			timeZoneOffsetOnInit,
			timeZoneOffsetOnSave,
			isDateBefore,
			compareDates,
			isFormattedDateValid
		}
	},
	created() {
		if (this.$route.params.uid && this.request.user_id!=this.$route.params.uid) {
			this.$store.dispatch('customer/loadWholeData', this.$route.params.uid);
		}
	},
	data() {
		return {
			request_loc: {},
			user_loc: {},
			cur_address_loc: {},
			old_address_loc: {},
			employer_address_loc: {},
			add_incomes_loc: [],
			children_loc: [],
			open_loans_loc: [],
			open_balances_loc: [],
			applicantForm: {},
			earningsForm: {},
			expensesForm: {},
			// controls' data
			genders: JSON.parse(this.$t('eny.genders')),
			civil: JSON.parse(this.$t('eny.civil')),
			yes_no_answers: JSON.parse(this.$t('eny.yes_no_answers')),
			nationalities: this.sortList(JSON.parse(this.$t('country.names')), 'value', 'label', null, JSON.parse(this.$t('country.priorityCountries'))),
			residence_permits: JSON.parse(this.$t('eny.residence_permits')),
			employment_rels: JSON.parse(this.$t('eny.employment_rels')),
			income_types: JSON.parse(this.$t('eny.income_types')),
			living_condition_types: JSON.parse(this.$t('eny.living_condition_types')),
			housing_types: JSON.parse(this.$t('eny.housing_types')),
			transport_to_work_types: JSON.parse(this.$t('eny.transport_to_work_types')),
			children_counts: JSON.parse(this.$t('eny.children_counts')),
			banks: this.sortList(JSON.parse(this.$t('eny.banks')), 'value', 'label', 'ot'),
			issuers: this.sortList(JSON.parse(this.$t('eny.issuers')), 'value', 'label', 'ot'),
			monthly_salary_amounts: JSON.parse(this.$t('eny.monthly_salary_amounts')),
			fields: { text: 'label', value: 'value' },
			cityFields: { text: 'City', value: 'City' },
			localeFields: { text: 'label', value: 'value' },
			zipCodes:{},
			multipleCity:false,
			oldAddressMultipleCity:false,
			employerMultipleCity:false,
			partnerCityMultiple:false,
			cities:{},
			oldAddressCities:{},
			employerCities:{},
			partnerCities:{},
		};
	},
	mounted() {
		// Configure applicant form.
		const applicantFormOptions = {
			rules: {
				dob: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.dob')})],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')]
				},
				nationality: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.nationality')})] },
				email: { required: [true, this.$t('eny.user_wrong_email_msg')], email: [true, this.$t('eny.user_wrong_email_msg')] },
				phone: {
					required: [true, this.$t('eny.field_empty')],
					regex: ["^(\\+41|0)(7[5-9])\\d{7}$", this.$t('eny.phone_not_valid_msg')],
				},
				residence_permit: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.residence_permit')})] },
				entry_date: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.entry_date')})],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')],
					min: [this.isAfterDob, this.$t('eny.date_les_then_date', { date1: this.$t('eny.entry_date'), date2: this.$t('eny.dob') })]
				},
				pending_enforcement: { required: [true, this.$t('eny.pending_enforcement_notempty_error_msg')] },
				cust_address_date: {
					required: [true, this.$t('eny.address_date_notempty_error_msg')],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')],
					min: [this.isAfterDob, this.$t('eny.date_les_then_date', {date1: this.$t('eny.date'), date2: this.$t('eny.dob')})]
				},
				cust_zip: {
					required: [true, this.$t('eny.field_empty')],
					number: [true, this.$t('eny.field_onlynumber_error_msg')]
				}
			},
			customPlacement: this.showValidationError,
		};
		this.applicantForm = new FormValidator("#dashboard-applicant-form", applicantFormOptions);
		// Configure earnings form.
		const earningsFormOptions = {
			rules: {
				employment_rel: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.employment_rel')})] },
				employment_rel_date: {
					required: [true, this.$t('eny.employment_rel_date_notempty_error_msg')],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')],
					min: [this.isAfterDob, this.$t('eny.date_les_then_date', { date1: this.$t('eny.employment_rel'), date2: this.$t('eny.dob') })]
				},
				employer_zip: { required: [true, this.$t('eny.field_notempty_error_msg')], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_has_partner_income: { required: [true, this.$t('eny.has_partner_income_notempty_error_msg')] },
				cust_partner_firstname: { required: [true, this.$t('eny.field_notempty_error_msg')] },
				cust_partner_lastname: { required: [true, this.$t('eny.field_notempty_error_msg')] },
				cust_partner_dob: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.dob')})],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')]
				},
				cust_partner_nationality: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.nationality')})] },
				cust_partner_phone: {
					required: [true, this.$t('eny.field_notempty_error_msg')],
					regex: ["^(\\+41|0)(7[5-9])\\d{7}$", this.$t('eny.phone_not_valid_msg')],
				},
				cust_partner_salary_number: { required: [true, this.$t('eny.field_notempty_error_msg')] },
				cust_partner_monthly_salary: { required: [true, this.$t('eny.field_notempty_error_msg')] },
				cust_partner_employer: { required: [true, this.$t('eny.field_notempty_error_msg')] },
				cust_partner_employer_street_nr: { required: [true, this.$t('eny.field_notempty_error_msg')] },
				cust_partner_employer_zip: { required: [true, this.$t('eny.field_notempty_error_msg')], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_partner_employer_city: { required: [true, this.$t('eny.field_notempty_error_msg')] },
				cust_partner_employment_rel: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.employment_rel')})] },
				cust_partner_employer_rel_since: {
					required: [true, this.$t('eny.field_notempty_error_msg')],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')],
					min: [this.isAfterPartnerDob, this.$t('eny.date_les_then_date', { date1: this.$t('eny.question_since_when'), date2: this.$t('eny.dob') })]
				},
			},
			customPlacement: this.showValidationError,
		};
		this.earningsForm = new FormValidator("#dashboard-earnings-form", earningsFormOptions);
		// Configure expenses form.
		const expensesFormOptions = {
			rules: {
			}
		};
		this.expensesForm = new FormValidator("#dashboard-expenses-form", expensesFormOptions);
		if (this.request) {
			this.initLocalData();
		}
		this.getZipMap();
	},
	methods: {
		getZipMap() {
			axios.get('/customer/getZipMap')
				.then((response) => {
					this.zipCodes = response.data;
				})
		},
		handleChange(e) {
			let cities="";
			let model="";
			let property="";
			let isMultiple="";
			switch (e.event.target.id) {
				case 'cust_zip': {
					cities = 'cities';
					model = 'cur_address_loc';
					property = 'city';
					isMultiple = 'multipleCity';
					break;
				}
				case 'cust_prev_zip': {
					cities = 'oldAddressCities';
					model = 'old_address_loc';
					property = 'city';
					isMultiple = 'oldAddressMultipleCity';
					break;
				}
				case 'employer_zip': {
					cities = 'employerCities';
					model = 'employer_address_loc';
					property = 'city';
					isMultiple = 'employerMultipleCity';
					break;
				}
				case 'employer_zip': {
					cities = 'employerCities';
					model = 'employer_address_loc';
					property = 'city';
					isMultiple = 'employerMultipleCity';
					break;
				}
				case 'cust_partner_employer_zip': {
					cities = 'partnerCities';
					model = 'request_loc';
					property = 'partner_employer_city';
					isMultiple = 'partnerCityMultiple';
					break;
				}
			}
			if (e.value.length === 4) {
				if (this.zipCodes[e.value]) {
					if (this.zipCodes[e.value].length!==undefined) {
						this[isMultiple] = true;
						this[cities] = this.zipCodes[e.value];
						this[model][property] = this[cities][0].City;
					}
					else {
						this[isMultiple] = false;
						this[model][property] = this.zipCodes[e.value].City;
					}
				}
			} else {
				this[isMultiple] = false;
				this[model][property] = "";
			}
		},
		onOpen: function(e) {
			this.sleep(10).then(function() {
				e.popup.offsetX = e.popup.relateTo.clientWidth - e.popup.properties.content.clientWidth;
			});
		},
		selectChildrenNumber: function(sel) {
			const number = parseInt(sel.itemData.value) || 0;
			const curLength = this.children_loc.length;
			const diff = number - curLength;
			if (diff > 0) {
				for (let i = 0; i < diff; ++i) {
					this.children_loc.push({age: "0"});
				}
			}
			else if (diff < 0) {
				this.children_loc.splice(diff);
			}
		},
		showValidationError: function(element, errorElement) {
			element.closest('.validation-group').querySelector('.error-element').appendChild(errorElement);
		},
		addAddIncome: function() {
			this.add_incomes_loc.push({amount: "", type: ""});
		},
		addOpenLoan: function() {
			this.open_loans_loc.push({bank: "", month_rate: "", open_balance: ""});
		},
		addOpenBalance: function() {
			this.open_balances_loc.push({issuer: "", month_rate: "", open_balance: ""});
		},
		initLocalData() {
			this.request_loc = this.request;
			this.user_loc = this.user;
			this.cur_address_loc = this.cur_address;
			this.old_address_loc = this.old_address;
			this.employer_address_loc = this.employer_address;
			this.add_incomes_loc = this.add_incomes;
			this.children_loc = this.children;
			this.open_loans_loc = this.open_loans;
			this.open_balances_loc = this.open_balances;
			this.request_loc.dob = this.timeZoneOffsetOnInit(this.request_loc.dob);
			this.request_loc.entry_date = this.timeZoneOffsetOnInit(this.request_loc.entry_date);
			this.request_loc.address_date = this.timeZoneOffsetOnInit(this.request_loc.address_date);
			this.request_loc.partner_dob = this.timeZoneOffsetOnInit(this.request_loc.partner_dob);
			this.request_loc.employment_rel_date = this.timeZoneOffsetOnInit(this.request_loc.employment_rel_date);
			this.request_loc.partner_employer_rel_since = this.timeZoneOffsetOnInit(this.request_loc.partner_employer_rel_since);
			if (this.request_loc.transport_to_work_type !== 'cc') {
				this.transport_to_work_types = this.transport_to_work_types.filter(
					(item) => item.value !== 'cc'
				);
			}
		},
		saveDashboardCustomerData: function() {
			this.adaptValidationRules();
			if (this.applicantForm.validate()) {
				const requestCopy  = { ...this.request_loc };
				requestCopy.dob = this.timeZoneOffsetOnSave(this.request_loc.dob);
				requestCopy.entry_date = this.timeZoneOffsetOnSave(this.request_loc.entry_date);
				requestCopy.address_date = this.timeZoneOffsetOnSave(this.request_loc.address_date);
				this.$store.dispatch('customer/store_dashboard_customer_data', { user: this.user_loc, request: requestCopy, cur_address: this.cur_address_loc, old_address: this.old_address_loc });
			}
		},
		sendEmailToCustomer: function () {
			this.$store.dispatch('customer/sendOffer', {userId: this.user_loc.id});
		},
		saveDashbordEarningsData: function() {
			this.adaptValidationRules();
			if (this.earningsForm.validate()) {
				const requestCopy  = { ...this.request_loc };
				requestCopy.partner_dob = this.timeZoneOffsetOnSave(this.request_loc.partner_dob);
				requestCopy.employment_rel_date = this.timeZoneOffsetOnSave(this.request_loc.employment_rel_date);
				requestCopy.partner_employer_rel_since = this.timeZoneOffsetOnSave(this.request_loc.partner_employer_rel_since);
				this.$store.dispatch('customer/store_dashboard_earnings_data', { request: requestCopy, employer_address: this.employer_address_loc, add_incomes: this.add_incomes_loc });
			}
		},
		saveDashbordExpensesData: function() {
			this.adaptValidationRules();
			if (this.expensesForm.validate()) {
				this.$store.dispatch('customer/store_dashboard_expenses_data', {request: this.request_loc, open_loans: this.open_loans_loc, open_balances: this.open_balances_loc, children: this.children_loc});
			}
		},
		adaptValidationRules: function() {
			if (this.request_loc.nationality == 'ch') {
				this.applicantForm.removeRules('residence_permit');
				this.applicantForm.removeRules('entry_date');
			}
			if (this.request_loc.civil_status != '1' || this.request_loc.has_partner_income != 1) {
				this.earningsForm.removeRules('cust_partner_firstname');
				this.earningsForm.removeRules('cust_partner_lastname');
				this.earningsForm.removeRules('cust_partner_dob');
				this.earningsForm.removeRules('cust_partner_nationality');
				this.earningsForm.removeRules('cust_partner_phone');
				this.earningsForm.removeRules('cust_partner_salary_number');
				this.earningsForm.removeRules('cust_partner_monthly_salary');
				this.earningsForm.removeRules('cust_partner_employer');
				this.earningsForm.removeRules('cust_partner_employer_street_nr');
				this.earningsForm.removeRules('cust_partner_employer_zip');
				this.earningsForm.removeRules('cust_partner_employer_city');
				this.earningsForm.removeRules('cust_partner_employment_rel');
				this.earningsForm.removeRules('cust_partner_employer_rel_since');
				if (this.request_loc.civil_status != '1') {
					this.earningsForm.removeRules('cust_has_partner_income');
				}
			}
		},
		isValidDate(input) {
			return this.isFormattedDateValid(input.value, this.$t('eny.moment_date_format'));
		},
		isAfterDob(input) {
			return this.compareDates(input.value, this.request_loc.dob, this.$t('eny.moment_date_format')) === 1;
		},
		isAfterPartnerDob: function(input) {
			return this.compareDates(input.value, this.request_loc.partner_dob, this.$t('eny.moment_date_format')) === 1;
		}
	},
	computed: {
		...mapGetters('customer', ['dashboard', 'request', 'user', 'cur_address', 'old_address', 'employer_address', 'add_incomes', 'children', 'open_loans', 'open_balances', 'loading', 'success', 'message']),
		...mapGetters('user', ['locales']),
		showOldAdress: function() {
			return this.request_loc.address_date
				? this.isDateBefore(this.request_loc.address_date, 12, 'months')
				: false;
		},
	},
	watch: {
		message(value, oldValue) {
			if (value!=='') {
				const type=this.success ? 'info' : 'error';
				this.showNotification(value, type, 5);
			}
		},
		loading(value, oldValue) {
			if (!value && oldValue) { // loading => not loading
				this.initLocalData();
			}
		}
	}
}
</script>

<style>
.e-grid .e-rowcell{
	font-size: 12px;
}
</style>
